import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP, BACKEND_API_URL} from "@/utils/http-common"

export default {
  /*async getAll($) {
    const path = `/business/donations`
    let results = (await HTTP.get(path)).data
    return results
  },*/

  async getAll($, params = {}) {
    const path = `/business/donations`;
    const res = (await HTTP.get(path, { params })).data;
    return res;
  },

  async get(actionId) {
    const path = `/business/donations/${actionId}`
    return (await HTTP.get(path)).data
  },

  async post(notification_object) {
    return new Promise((resolve, reject) => {
      HTTP.post(`business/donations`, notification_object)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  async authorize(donationId) {
    return new Promise((resolve, reject) => {
      HTTP.post(`business/donations/${donationId}/approved`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  async reject(donationId) {
    return new Promise((resolve, reject) => {
      HTTP.post(`business/donations/${donationId}/rejected`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  // Validation interne d'un don : POST /business/donations/<id>/approve
  // body: { approve: true|false }
  // Reservee aux users avec privilege validate_donation (ou admin).
  async approve(donationId, approveFlag = true) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/business/donations/${donationId}/approve`, { approve: approveFlag })
        .then(r => resolve(r.data))
        .catch(e => reject(e))
    })
  },

  async put(data) {
    const { id, ...others } = data
    const path = `/business/donations/${id}`
    return (await HTTP.put(path, others)).data
  },

  async delete(actionId) {
    const path = `/business/donations/${actionId}`
    return (await HTTP.delete(path)).data
  },

  async getBadge($, vehicleId) {
    return new Promise((resolve, reject) => {
      const url = `${BACKEND_API_URL}/business/donations/${vehicleId}/badge`;

      const xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.setRequestHeader("authorization", "Token " + $.$store.state.app.user.key);
      xhr.setRequestHeader("X-Timezone-Name", $.$store.state.app.user.tzName);
      xhr.responseType = "blob";

      xhr.onload = function () {
        if (xhr.status === 200) {
          const blobUrl = URL.createObjectURL(xhr.response);
          resolve(blobUrl);
        } else {
          reject(xhr);
        }
      };

      xhr.onerror = function () {
        reject(xhr);
      };

      xhr.send();
    });
  }
}
